export default function joinUnderscoreStringUtil (...paths) {
  return paths.join('_')
}
